import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { FranchiseComponent }               from './franchise.component';
import { FranchisesOwnerSettingsComponent } from './franchises.owner-settings.component';
import { FranchisesService }                from './franchises.service';
import { FranchisesSettingsComponent }      from './franchises.settings.component';
import { FranchisesStates }                 from './franchises.states';
import { SharedModule }                     from '../shared/shared.module';
import { TableModule }                      from '../table/table.module';

@NgModule({
  declarations: [
    FranchiseComponent,
    FranchisesOwnerSettingsComponent,
    FranchisesSettingsComponent
  ],
  entryComponents: [
    FranchiseComponent,
    FranchisesOwnerSettingsComponent,
    FranchisesSettingsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: FranchisesStates })
  ],
  providers: [
    FranchisesService
  ]
})
export class FranchisesModule {}
